module.exports = __webpack_public_path__ + "static/media/weather.1deccad4.PNG";